import { ChangeDetectorRef, Component, OnInit, ViewEncapsulation } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { fuseAnimations } from "@fuse/animations";
import { map, Observable } from "rxjs";

import { MAT_DATE_LOCALE } from "@angular/material/core";
import { MatDialog } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { ActivatedRoute, Router } from "@angular/router";
import { OperadorCartaConsorcioModel } from "app/auxiliares/models/operador-carta-consorcio.model";
import { ParceiroCartaConsorcioModel } from "app/auxiliares/models/parceiro-carta-consorcio.model";
import { StatusCartaConsorcioModel } from "app/auxiliares/models/status-carta-consorcio.model";
import { StatusMovimentacao } from "app/auxiliares/models/status-movimentacao.model";
import { OperadorCartaConsorcioService } from "app/auxiliares/services/operador-carta-consorcio-service";
import { ParceiroCartaConsorcioService } from "app/auxiliares/services/parceiro-carta-consorcio-service";
import { StatusCartaConsorcioService } from "app/auxiliares/services/status-carta-consorcio-service";
import { StatusMovimentacaoService } from "app/auxiliares/services/status-movimentacao.service";
import { CadastroClienteSimplesComponent } from "app/clientes/cadastro-cliente-simples/cadastro-cliente-simples.component";
import { ClienteModel } from "app/clientes/models/cliente.model";
import { ClienteService } from "app/clientes/services/cliente.service";
import { BaseComponent, LoadingTeste } from "../../base-module/base-component/base.component";
import { AuthService } from "../../base-module/base-service/auth.service";
import { CadastroCartaBoletaConsorcio } from "../manter-carta-boleta-consorcio/cadastro-carta-boleta-consorcio.component";
import { FiltroCartaBoletaConsorcioComponent } from "../manter-carta-boleta-consorcio/filtro-carta-boleta-consorcio/filtro-carta-boleta-consorcio.component";
import { CaracteristicaProdutoConsorcioModel } from "../models/caracteristica-produto-consorcio.model";
import { EmpresaConsorcioModel } from "../models/empresa-consorcio.model";
import { TipoConsorcio } from "../models/tipo-consorcio.model";
import { BoletaConsorcioService } from "../services/boleta-consorcio.service";
import { CaracteristicaProdutoConsorcioService } from "../services/caracteristica-produto-consorcio.service";
import { EmpresaConsorcioService } from "../services/empresa-consorcio.service";
import { TipoConsorcioService } from "../services/tipo-consorcio.service";

export interface ILance {
    tipo_lance_id: number;
    carta_id: number;
    valor_lance: number;
}

export interface ICarta {
    id?: number | null;
    grupo: string;
    cota: string;
    prazo_grupo: Date;
    taxa_administrativa_grupo: number;
    fechamento_id: number;
    status_id: number;
    desconto: number;
    data_fechamento: Date;
    data_pagamento: Date;
    valor_carta: number;
    lances?: ILance[];
    // lance:number;
    valor: number;
    boleta_id?: number | null;
    data_contemplacao?: Date;
}

interface IModel {
    status_id: number | null;
    parceiro_consorcio_id: number | null;
    operador_consorcio_id: number | null;
    cliente_id: number | null;
    tipo_consorcio_id: number | null;
    data_assembleia: Date | null;
    data_retorno: Date | null;
    qtd_cartas: number | null;
    valor: number | null;
    observacao: string | null;
    cartas: ICarta[] | null;
    is_recorrente: boolean | null;
    is_fixo_livre: string | null;
}

@Component({
    selector: "app-cadastro-boleta-consorcio",
    templateUrl: "./cadastro-boleta-consorcio.component.html",
    styleUrls: ["./cadastro-boleta-consorcio.component.scss"],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations,
    providers: [{ provide: MAT_DATE_LOCALE, useValue: "pt-BR" }],
})
export class CadastroBoletaConsorcioComponent extends BaseComponent implements OnInit {
    loadingSpinner: boolean = false;

    filteredOptions!: Observable<ClienteModel[]>;
    boletaFormGroup: FormGroup = new FormGroup({
        cliente: new FormControl("", [Validators.required]),
        cliente_id: new FormControl("", [Validators.required]),
        status_id: new FormControl(null, [Validators.required]),
        produto_consorcio_id: new FormControl(null),
        valor: new FormControl(),
        observacao: new FormControl(),
        data_assembleia: new FormControl(null),
        data_retorno: new FormControl(null),
        parceiro_consorcio_id: new FormControl(null, [Validators.required]),
        operador_consorcio_id: new FormControl(null, [Validators.required]),
        qtd_cartas: new FormControl(null),
        tipo_consorcio_id: new FormControl(null, [Validators.required]),
        is_recorrente: new FormControl(),
        is_fixo_livre: new FormControl(),
    });

    listStatus: StatusMovimentacao[] = [];
    loadingSpinnerStatus: boolean = false;

    listProdutoConsorcio: CaracteristicaProdutoConsorcioModel[] = [];
    loadingSpinnerProduto: boolean = false;

    model: IModel = {
        status_id: null,
        parceiro_consorcio_id: null,
        operador_consorcio_id: null,
        cliente_id: null,
        tipo_consorcio_id: null,
        data_assembleia: null,
        data_retorno: null,
        qtd_cartas: null,
        valor: null,
        observacao: null,
        cartas: [],
        is_recorrente: null,
        is_fixo_livre: null,
    };

    loadingLocal: any;

    listTipoConsorcio: TipoConsorcio[] = [];
    loadingSpinnerTipo: boolean = false;

    listEmpresaConsorcio: EmpresaConsorcioModel[] = [];
    loadingSpinnerEmpresaConsorcio: boolean = false;

    listOperadorConsorcio: OperadorCartaConsorcioModel[] = [];
    loadingSpinnerOperadorConsorcio: boolean = false;

    listParceiroConsorcio: ParceiroCartaConsorcioModel[] = [];
    loadingSpinnerParceiroConsorcio: boolean = false;

    listStatusCartaConsorcio: StatusCartaConsorcioModel[] = [];
    loadingSpinnerStatusCartaConsorcio: boolean = false;

    data: any = {
        id: null,
    };
    selectCartaEdit: ICarta | null = null;
    selectCartaIndex: number | null = null;
    paramsCarta: any = {
        boleta_id: null,
        page: 0,
        per_page: 10,
    };
    filterCarta: any = {
        grupo: "",
        cota: "",
        status_id: "",
        reload: "",
    };

    constructor(
        public service: BoletaConsorcioService,
        public dialog: MatDialog,
        override snackBar: MatSnackBar,
        private loading: MatDialog,
        public authService: AuthService,
        private _clienteService: ClienteService,
        private _statusService: StatusMovimentacaoService,
        private _produtoService: CaracteristicaProdutoConsorcioService,
        private _tipoService: TipoConsorcioService,
        private _empresaConsorcioService: EmpresaConsorcioService,
        public _Activatedroute: ActivatedRoute,
        private _parceiroCartaService: ParceiroCartaConsorcioService,
        private _operadorCartaService: OperadorCartaConsorcioService,
        private ref: ChangeDetectorRef,
        private route: Router,
        private _statusCartaService: StatusCartaConsorcioService
    ) {
        super(dialog, snackBar);
    }

    /**
     * Inicializa o componente carregando dados da boleta e configurando formulário
     */
    ngOnInit(): void {
        this.pageSize = this.paramsCarta.per_page;
        this.pageSizeOptions = [10, 20, 30, 100];

        if (this._Activatedroute.snapshot.params["id"]) {
            this.data.id = this._Activatedroute.snapshot.params["id"];
        }
        this.loadingIndicator = false;

        if (this.data.id) {
            this.getById();
        }

        this.boletaFormGroup.get("cliente")!.valueChanges.subscribe(async (query) => {
            if (typeof query === "string" || typeof query === "number") {
                this.loadingSpinner = true;
                this.params.search = query;
                this.filteredOptions = await this._clienteService.search(this.params).pipe(map(response => response.data));
            }
        });

        this.getAllStatus();
        this.getAllProdutoConsorcio();
        this.getAllTipoConsorcio();
        this.getAllEmpresaConsorcio();
        this.getAllParceiroCarta();
        this.getAllOperador();
        this.getAllStatusCarta();
    }

    /**
     * Abre diálogo de loading local
     */
    openLoadingLocal(): void {
        this.loadingLocal = this.loading.open(LoadingTeste, {
            width: "150px",
            disableClose: true,
        });
    }

    /**
     * Fecha diálogo de loading local
     */
    closeLoadingLocal(): void {
        if (this.loadingLocal !== null) {
            this.loadingLocal.close();
        }
    }

    /**
     * Salva ou atualiza a boleta de consórcio
     */
    salvar(): void {
        this.model = this.buildModel();
        if (this.boletaFormGroup.valid) {
            this.openLoading();
            if (!this.data.id) {
                this.service.create(this.model).subscribe({
                    next: (_data) => {
                        this.closeLoading();
                        this.route.navigate(["/consorcio/lista-boleta-consorcio"]);
                    },
                    error: (error) => {
                        this.closeLoading();
                        this.showError(`Erro ao criar boleta: ${error.error?.message || error.message}`);
                    },
                    complete: () => {
                        // Loading será fechado em next ou error
                    },
                });
            } else {
                this.service.update(this.data.id, this.model).subscribe({
                    next: (_data) => {
                        this.closeLoading();
                        this.route.navigate(["/consorcio/lista-boleta-consorcio"]);
                    },
                    error: (error) => {
                        this.closeLoading();
                        this.showError(`Erro ao atualizar boleta: ${error.error?.message || error.message}`);
                    },
                    complete: () => {
                        // Loading será fechado em next ou error
                    },
                });
            }
        } else {
            if (this.boletaFormGroup.invalid) {
                this.validateAllFormFields(this.boletaFormGroup);
            }
        }
    }

    /**
     * Marca todos os campos do formulário como touched para exibir erros de validação
     * @param formGroup - FormGroup a ser validado
     */
    validateAllFormFields(formGroup: FormGroup): void {
        Object.keys(formGroup.controls).forEach((field) => {
            const control = formGroup.get(field);
            if (control instanceof FormControl) {
                control.markAsTouched({ onlySelf: true });
            } else if (control instanceof FormGroup) {
                this.validateAllFormFields(control);
            }
        });
    }

    /**
     * Retorna mensagem de erro do campo cliente
     * @returns Mensagem de erro ou string vazia
     */
    getErrorClienteMessage(): string {
        return this.boletaFormGroup.get("cliente")!.hasError("required") ? "Cliente é um campo obrigatório" : "";
    }

    /**
     * Retorna mensagem de erro do campo status
     * @returns Mensagem de erro ou string vazia
     */
    getErrorStatusMessage(): string {
        return this.boletaFormGroup.get("status_id")!.hasError("required") ? "Status é um campo obrigatório" : "";
    }

    /**
     * Retorna mensagem de erro do campo produto
     * @returns Mensagem de erro ou string vazia
     */
    getErrorProdutoMessage(): string {
        return this.boletaFormGroup.get("produto_consorcio_id")!.hasError("required")
            ? "Produto é um campo obrigatório"
            : "";
    }

    /**
     * Retorna mensagem de erro do campo valor
     * @returns Mensagem de erro ou string vazia
     */
    getErrorValorMessage(): string {
        return this.boletaFormGroup.get("valor")!.hasError("required") ? "Valor é um campo obrigatório" : "";
    }

    /**
     * Busca dados da boleta pelo ID e preenche o formulário
     */
    getById(): void {
        this.openLoading();
        this.service.getById(this.data.id).subscribe({
            next: (item) => {
                // this.rows = this.buildCartas(item.data.cartas);
                this.boletaFormGroup.get("cliente")!.setValue(item.data.cliente);
                this.boletaFormGroup.get("cliente_id")!.setValue(item.data.cliente_id);
                this.boletaFormGroup.get("status_id")!.setValue(item.data.status_id);
                this.boletaFormGroup.get("produto_consorcio_id")!.setValue(item.data.produto_id);
                this.boletaFormGroup.get("valor")!.setValue(item.data.valor);
                this.boletaFormGroup.get("observacao")!.setValue(item.data.observacao);
                if (item.data.data_assembleia) {
                    const [year, month, day] = item.data.data_assembleia.split("-").map(Number);
                    this.boletaFormGroup.get("data_assembleia")!.setValue(new Date(year, month - 1, day));
                }
                if (item.data.data_retorno) {
                    this.boletaFormGroup.get("data_retorno")!.setValue(new Date(item.data.data_retorno));
                }
                this.boletaFormGroup.get("parceiro_consorcio_id")!.setValue(item.data.parceiro_consorcio_id);
                this.boletaFormGroup.get("operador_consorcio_id")!.setValue(item.data.operador_consorcio_id);
                this.boletaFormGroup.get("qtd_cartas")!.setValue(item.data.qtd_cartas);
                this.boletaFormGroup.get("tipo_consorcio_id")!.setValue(item.data.tipo_consorcio_id);
                this.boletaFormGroup.get("is_recorrente")!.setValue(item.data.is_recorrente);
                this.boletaFormGroup.get("is_fixo_livre")!.setValue(item.data.is_fixo_livre);
            },
            error: (error) => {
                this.closeLoading();
                this.showError(`Erro ao buscar boleta: ${error.error?.message || error.message}`);
            },
            complete: () => {
                this.closeLoading();
            },
        });
    }

    /**
     * Retorna o nome do cliente para exibição no autocomplete
     * @param cliente - Objeto cliente ou null
     * @returns Nome do cliente ou string vazia
     */
    displayFn(cliente: { nome: string } | null): string {
        if (cliente) {
            return cliente.nome;
        }
        return "";
    }

    /**
     * Define o cliente selecionado no formulário
     * @param cliente - Objeto cliente selecionado
     */
    getCliente(cliente: ClienteModel): void {
        this.boletaFormGroup.get("cliente_id")!.setValue(cliente.id);
        this.loadingSpinner = false;
    }

    /**
     * Busca todos os status disponíveis para boletas de consórcio
     */
    getAllStatus(): void {
        this.loadingSpinnerStatus = true;

        this._statusService.getLista({ tipo_produto: "CS" }).subscribe({
            next: (list) => {
                this.listStatus = list.data ?? [];
            },
            error: (error) => {
                this.loadingSpinnerStatus = false;
                this.showError(`Erro ao buscar status: ${error.error?.message || error.message}`);
            },
            complete: () => {
                this.loadingSpinnerStatus = false;
            },
        });
    }

    /**
     * Busca todos os produtos de consórcio disponíveis
     */
    getAllProdutoConsorcio(): void {
        this.loadingSpinnerProduto = true;

        this._produtoService.getLista({}).subscribe({
            next: (list) => {
                this.listProdutoConsorcio = list.data;
            },
            error: (error) => {
                this.loadingSpinnerProduto = false;
                this.showError(`Erro ao buscar produtos: ${error.error?.message || error.message}`);
            },
            complete: () => {
                this.loadingSpinnerProduto = false;
            },
        });
    }

    /**
     * Busca todos os tipos de consórcio disponíveis
     */
    getAllTipoConsorcio(): void {
        this.loadingSpinnerTipo = true;
        this._tipoService.getAll({ no_paginate: true }).subscribe({
            next: (list) => {
                this.listTipoConsorcio = list.data ?? [];
            },
            error: (error) => {
                this.loadingSpinnerTipo = false;
                this.showError(`Erro ao buscar tipos de consórcio: ${error.error?.message || error.message}`);
            },
            complete: () => {
                this.loadingSpinnerTipo = false;
            },
        });
    }

    /**
     * Busca todas as empresas de consórcio disponíveis
     */
    getAllEmpresaConsorcio(): void {
        this.loadingSpinnerEmpresaConsorcio = true;
        this._empresaConsorcioService.getAll({ no_paginate: true }).subscribe({
            next: (list) => {
                this.listEmpresaConsorcio = list.data ?? [];
            },
            error: (error) => {
                this.loadingSpinnerEmpresaConsorcio = false;
                this.showError(`Erro ao buscar empresas: ${error.error?.message || error.message}`);
            },
            complete: () => {
                this.loadingSpinnerEmpresaConsorcio = false;
            },
        });
    }

    /**
     * Abre diálogo para cadastro de novo cliente
     */
    cadastroCliente(): void {
        const dialogRef = this.dialog.open(CadastroClienteSimplesComponent, {
            width: "600px",
            data: {
                abordagem: false,
            },
        });

        dialogRef.afterClosed().subscribe({
            next: (result: any) => {
                if (result !== undefined && result !== null && result !== "cancel") {
                    this.showSuccess("Cliente cadastrado com sucesso!");
                }
            },
        });
    }

    /**
     * Busca todos os parceiros de carta de consórcio disponíveis
     */
    getAllParceiroCarta(): void {
        this.loadingSpinnerParceiroConsorcio = true;
        this._parceiroCartaService.getAll({ no_paginate: true }).subscribe({
            next: (list) => {
                this.listParceiroConsorcio = list.data ?? [];
            },
            error: (error) => {
                this.loadingSpinnerParceiroConsorcio = false;
                this.showError(`Erro ao buscar parceiros: ${error.error?.message || error.message}`);
            },
            complete: () => {
                this.loadingSpinnerParceiroConsorcio = false;
            },
        });
    }

    /**
     * Busca todos os operadores de consórcio disponíveis
     */
    getAllOperador(): void {
        this.loadingSpinnerOperadorConsorcio = true;
        this._operadorCartaService.getAll({ no_paginate: true }).subscribe({
            next: (list) => {
                this.listOperadorConsorcio = list.data;
            },
            error: (error) => {
                this.loadingSpinnerOperadorConsorcio = false;
                this.showError(`Erro ao buscar operadores: ${error.error?.message || error.message}`);
            },
            complete: () => {
                this.loadingSpinnerOperadorConsorcio = false;
            },
        });
    }

    /**
     * Constrói o modelo de dados da boleta a partir do formulário
     * @returns Modelo IModel com os dados do formulário e cartas
     */
    buildModel(): IModel {
        const buildModel: IModel = {
            ...this.boletaFormGroup.value,
            cartas: this.rows,
        };
        return buildModel;
    }

    /**
     * Handler para evento de edição de carta (atualmente não implementado)
     * @param _event - Evento contendo dados da carta a ser editada
     */
    eventoEdicaoCarta(_event: any): void {
        // this.editCarta(evento.row, evento.index);
    }

    /**
     * Adiciona uma nova carta à lista de cartas da boleta
     * @param event - Evento contendo os dados da carta a ser adicionada
     */
    addCarta(event: any): void {
        this.ref.markForCheck();
        this.rows.push(event.carta);
        this.rows = [...this.rows];
        this.temp = [...this.rows];
        this.length = this.rows.length;
        this.ref.detectChanges();
    }

    /**
     * Abre diálogo para editar uma carta existente
     * @param row - Dados da carta a ser editada
     * @param rowIndex - Índice da carta na lista
     */
    editCarta(row: ICarta, rowIndex: number): void {
        this.selectCartaEdit = row;
        this.selectCartaIndex = rowIndex;

        const dialogRef = this.dialog.open(CadastroCartaBoletaConsorcio, {
            width: "700px",
            maxHeight: "99vh",
            data: {
                boletaId: null,
                cartaId: null,
                parceiroConsorcioId: this.boletaFormGroup.get("parceiro_consorcio_id")!.value,
                cartaEdit: row,
            },
        });

        dialogRef.afterClosed().subscribe({
            next: (result) => {
                if (result !== "cancel" && result !== "reload-list") {
                    this.saveEditCarta(result);
                }
            },
        });
    }

    /**
     * Remove uma carta da lista de cartas da boleta
     * @param rowIndex - Índice da carta a ser removida
     */
    deleteCarta(rowIndex: number): void {
        // Marca estado inicial
        this.ref.markForCheck();

        // Remove o item da posição correta
        this.rows.splice(rowIndex, 1);

        // Cria uma nova referência para o array
        this.rows = [...this.rows];

        // Atualiza o comprimento da lista
        this.length = this.rows.length;

        // Força a detecção de mudanças
        this.ref.detectChanges();
    }

    /**
     * Salva uma carta editada substituindo a carta original na lista
     * @param event - Evento contendo os dados da carta editada
     */
    saveEditCarta(event: any): void {
        if (this.selectCartaIndex) this.deleteCarta(this.selectCartaIndex);
        this.selectCartaEdit = null;
        this.ref.markForCheck();
        this.rows.push(event.carta);
        this.rows = [...this.rows];
        this.temp = [...this.rows];
        this.length = this.rows.length;
        this.ref.detectChanges();
    }

    /**
     * Abre diálogo para cadastro de nova carta
     */
    openCadastroCarta(): void {
        const dialogRef = this.dialog.open(CadastroCartaBoletaConsorcio, {
            width: "800px",
            maxHeight: "99vh",
            data: {
                boletaId: this.data.id ? this.data.id : null,
                cartaId: this.selectCartaEdit ? this.selectCartaEdit.id : null,
                parceiroConsorcioId: this.boletaFormGroup.get("parceiro_consorcio_id")?.value,
            },
        });

        dialogRef.afterClosed().subscribe({
            next: (result) => {
                if (result !== "cancel" && result !== "reload-list") {
                    this.addCarta(result);
                }

                if (result === "reload-list") {
                    this.filterCarta = {
                        grupo: result.grupo ?? "",
                        cota: result.cota ?? "",
                        status_id: result.status_id ?? "",
                        reload: !this.filterCarta.reload,
                    };
                }
            },
        });
    }

    /**
     * Abre diálogo de filtro para consulta de cartas
     */
    openFiltroCarta(): void {
        const dialogRef = this.dialog.open(FiltroCartaBoletaConsorcioComponent, {
            width: "700px",
            maxHeight: "99vh",
        });

        dialogRef.afterClosed().subscribe((result) => {
            if (result !== "cancel") {
                this.filterCarta = {
                    grupo: result.grupo ?? "",
                    cota: result.cota ?? "",
                    status_id: result.status_id ?? "",
                    reload: true,
                };
            }
        });
    }

    /**
     * Busca todos os status de carta de consórcio disponíveis
     */
    getAllStatusCarta(): void {
        this.loadingSpinnerStatusCartaConsorcio = true;
        this._statusCartaService.getAll({ no_paginate: true }).subscribe({
            next: (list) => {
                this.listStatusCartaConsorcio = list.data ?? [];
            },
            error: (error) => {
                this.loadingSpinnerStatusCartaConsorcio = false;
                this.showError(`Erro ao buscar status de cartas: ${error.error?.message || error.message}`);
            },
            complete: () => {
                this.loadingSpinnerStatusCartaConsorcio = false;
            },
        });
    }

    /**
     * Retorna o nome do status de carta pelo ID
     * @param id - Identificador do status
     * @returns Nome do status ou string vazia se não encontrado
     */
    getNameStatusCartaById(id: number): string {
        let nome = "";
        for (let i = 0; i < this.listStatusCartaConsorcio.length; i++) {
            const element = this.listStatusCartaConsorcio[i];
            if (id === element.id) {
                nome = element.nome;
                break; // Interrompe o loop quando o id é encontrado
            }
        }
        return nome;
    }
}
